import script from "./SelfService2.vue?vue&type=script&setup=true&lang=js"
export * from "./SelfService2.vue?vue&type=script&setup=true&lang=js"

import "./SelfService2.vue?vue&type=style&index=0&id=34b67bbf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34b67bbf"]])

export default __exports__